import { Component, Input, OnInit } from '@angular/core';
import IActiveConnections = Authorization.IActiveConnections;
import {ExternalLinkService} from "../../../core/services";

@Component({
    standalone: false,
    selector: 'app-active-connected-users-btn',
    templateUrl: './active-connected-users-btn.component.html',
    styleUrls: ['./active-connected-users-btn.component.scss']

})
export class ActiveConnectedUsersBtnComponent implements OnInit {
    @Input()
    activeConnection: IActiveConnections;

    get activeConnectionsAmount(): number {
         return this.activeConnection ? this.activeConnection.users.length : 0;
    }

    get hasMultipleConnections(): boolean {
        return this.activeConnectionsAmount > 1;
    }

    get isImportSection(): boolean {
        return this.externalLinkService.isImportSection();
    }

    constructor( private externalLinkService: ExternalLinkService) {
    }

    ngOnInit() {
    }

}
